export function buildPartialPayload<T extends Record<string, unknown>>(values: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(values).filter(([, v]) => v !== null && v !== undefined && v !== ""),
  ) as Partial<T>;
}

export function hasAnyValue(payload: Record<string, unknown>): boolean {
  return Object.keys(payload).length > 0;
}
